// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.preview.RentalManagerUserListingPreviewWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserListingPreviewWebApiHandler_getListingPreviewUrl,
  RentalManagerUserListingPreviewWebApiHandler_getListingPreviewUrl_Path,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type { ListingAlias } from '@zg-rentals/ts-rental-manager-api-beta-client';

interface GetListingPreviewUrlParams {
  listingAlias: ListingAlias;
}

export type RentalManagerUserListingPreviewWebApiHandler_getListingPreviewUrl_Options = UseQueryOptions<
  string,
  unknown,
  string,
  readonly [string, GetListingPreviewUrlParams]
>;

const RentalManagerUserListingPreviewWebApiHandler_getListingPreviewUrl_GetKey = (
  getParams: GetListingPreviewUrlParams,
) => [RentalManagerUserListingPreviewWebApiHandler_getListingPreviewUrl_Path, getParams] as const;

export const RentalManagerUserListingPreviewWebApiHandler_getListingPreviewUrl_queryOptions = (
  getParams: GetListingPreviewUrlParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserListingPreviewWebApiHandler_getListingPreviewUrl_GetKey(getParams),
    queryFn: () => RentalManagerUserListingPreviewWebApiHandler_getListingPreviewUrl(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get the listing preview URL
 */
export const useRentalManagerUserListingPreviewWebApiHandler_getListingPreviewUrl = (
  getParams: GetListingPreviewUrlParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserListingPreviewWebApiHandler_getListingPreviewUrl_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserListingPreviewWebApiHandler_getListingPreviewUrl_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserListingPreviewWebApiHandler_getListingPreviewUrl.getKey =
  RentalManagerUserListingPreviewWebApiHandler_getListingPreviewUrl_GetKey;
